import { Form } from "formik";
import styled from "styled-components";

import { FlexProps } from "./FlexBox";

export const CustomForm = styled(Form)<FlexProps>`
  display: flex;
  flex-direction: ${p => p.direction || "column"};
  align-items: ${p => p.align || "center"};
  justify-content: ${p => p.justify || "flex-start"};
  height: ${p => p.height || "100%"};

  ${p => p.position && `position: ${p.position}`};

  ${p => p.flex && `flex: ${p.flex}`};
  ${p => p.wrap && `flex-wrap: ${p.wrap}`};
  ${p => p.direction && `flex-direction: ${p.direction}`};
  ${p => p.alignSelf && `align-self: ${p.alignSelf}`};

  ${p => p.padding && `padding: ${p.padding}`};
  ${p => p.margin && `margin: ${p.margin}`};

  ${p => p.width && `width: ${p.width}`};
  ${p => p.maxWidth && `max-width: ${p.maxWidth}`};
  ${p => p.minWidth && `min-width: ${p.minWidth}`};

  ${p => p.maxHeight && `max-height: ${p.maxHeight}`};
  ${p => p.minHeight && `min-height: ${p.minHeight}`};

  ${p => p.overflow && `overflow: ${p.overflow}`};
`;
